import React from 'react';
import { useRadioStyles } from 'components/UI/V2/Forms/Radio/Radio.styles';
import { Label } from 'components/UI/V2/Forms/Label/Label';
import { Typography } from '@material-ui/core';

type RadioProps = Omit<React.ComponentProps<'input'>, 'onChange'> & {
    error?: string;
    label?: string;
    inlineLabel?: string;
    description?: string;
    onChange?: (checked: boolean) => void;
};

export const Radio: React.FC<RadioProps> = ({ error, label, inlineLabel, description, ...inputProps }) => {
    const classes = useRadioStyles();

    return (
        <div
            className={classes.root}
            onClick={() => inputProps.onChange?.(true)}
        >
            {label && <Label error={error}>{label}</Label>}

            <div className={classes.optionContainer}>
                <div className={classes.radioContainer}>
                    <input
                        type="radio"
                        {...inputProps}
                        className={classes.input}
                        checked={inputProps.checked}
                        onChange={event => inputProps.onChange?.(event.target.checked)}
                    />

                    {inlineLabel && <Typography className={classes.optionLabel}>{inlineLabel}</Typography>}
                </div>

                {description && <Typography className={classes.optionDescription}>{description}</Typography>}
            </div>
        </div>
    );
};
